export const environment = (): string => {
  if (typeof window === 'undefined') {
    return 'prod'
  } else {
    if (window.location?.hostname) {
      switch (true) {
        case window.location?.hostname.includes('dev-ecs.components.product.which.co.uk'):
        case window.location?.hostname === 'localhost':
        case window.location?.hostname === 'dev-deliver.components.product.which.co.uk':
        case window.location?.hostname === 'dev.internal.which.co.uk':
          return 'dev'
        case window.location?.hostname === 'test-deliver.components.product.which.co.uk':
        case window.location?.hostname === 'test.internal.which.co.uk':
          return 'test'
        case window.location?.hostname === 'qa-deliver.components.product.which.co.uk':
          return 'qa'

        case window.location?.hostname.includes('preprod-ecs.components.product.which.co.uk'):
        case window.location?.hostname === 'preprod-deliver.components.product.which.co.uk':
        case window.location?.hostname === 'preprod.internal.which.co.uk':
          return 'preprod'
        default:
          return 'prod'
      }
    }
    return 'prod'
  }
}
